import React, { useState } from 'react';
import clsx from 'clsx';

interface TooltipProps {
  text: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  spacing?: 'normal' | 'compact' | 'tall';
}

export const Tooltip: React.FC<TooltipProps> = ({
  text,
  children,
  className,
  spacing = 'normal',
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  if (!text) return <>{children}</>;

  return (
    <div
      className={className ?? 'relative inline-block'}
      onFocus={() => {}}
      onMouseOver={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip ? (
        <span
          className={clsx(
            'absolute left-1/2 bg-black text-white text-xs rounded-md z-50 whitespace-nowrap select-none pointer-events-none flex flex-col items-center justify-center animate-tooltip-fade-in',
            'after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:h-0 after:w-0 after:border-x-4 after:border-x-transparent after:border-t-[4px] after:border-t-black',
            {
              'px-3 py-1.5 -translate-x-1/2 -top-10': spacing === 'normal',
              'px-2 py-1 -translate-x-1/2 -top-8': spacing === 'compact',
              'px-3 py-2 -translate-x-1/2 -top-14': spacing === 'tall',
            },
          )}
          style={{
            animation: 'tooltipFadeIn 0.3s ease-out',
          }}
        >
          {text}
        </span>
      ) : null}
      <style>{`
        @keyframes tooltipFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};
